"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _tinycolor = _interopRequireDefault(require("tinycolor2"));

require("../styles/_labels.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var EditLabels = /*#__PURE__*/function (_Component) {
  _inherits(EditLabels, _Component);

  var _super = _createSuper(EditLabels);

  function EditLabels(props) {
    var _this;

    _classCallCheck(this, EditLabels);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "resetEditingLabel", function () {
      _this.setState({
        editingLabel: void 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "editLabel", function (label) {
      return function () {
        _this.setState({
          editingLabel: label
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "selectLabel", function (labelId) {
      return function () {
        var selectedLabels = _this.state.selectedLabels;
        var selectedIndex = selectedLabels.findIndex(function (selectedId) {
          return selectedId === labelId;
        });

        if (selectedIndex >= 0) {
          var newSelected = _toConsumableArray(selectedLabels);

          newSelected.splice(selectedIndex, 1);
          return void _this.setState({
            selectedLabels: newSelected
          });
        }

        _this.setState({
          selectedLabels: [].concat(_toConsumableArray(selectedLabels), [labelId])
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "renderLabel", function (label) {
      var text = label.label,
          color = label.color,
          id = label.id;
      var selectedLabels = _this.state.selectedLabels;
      var brightness = (0, _tinycolor.default)(color).getBrightness();
      var textColor = brightness > 126 ? 'black' : 'white';
      var isSelected = selectedLabels.some(function (selectedId) {
        return selectedId === id;
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "labels__content__label-container",
        key: id
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        onClick: _this.selectLabel(id),
        className: "labels__content__label",
        style: {
          background: color,
          color: textColor
        }
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "labels__content__label__text"
      }, isSelected ? /*#__PURE__*/_react.default.createElement("strong", null, text) : text), isSelected ? /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
        name: "success",
        color: textColor,
        size: 15
      }) : null), /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
        hoverColor: "black",
        onClick: _this.editLabel(label),
        name: "edit",
        color: "regent",
        size: 15
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "onUpdateEditingLabel", function (_ref) {
      var value = _ref.target.value;

      _this.setState(function (_ref2) {
        var editingLabel = _ref2.editingLabel;
        return {
          editingLabel: _objectSpread(_objectSpread({}, editingLabel), {}, {
            label: value
          })
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onUpdateEditingColor", function (_ref3) {
      var hex = _ref3.hex;

      _this.setState(function (_ref4) {
        var editingLabel = _ref4.editingLabel;
        return {
          editingLabel: _objectSpread(_objectSpread({}, editingLabel), {}, {
            color: hex
          })
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderEditContent", function () {
      var editingLabel = _this.state.editingLabel;

      if (!editingLabel) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_uiKit.ColorPicker, {
        key: "color-picker",
        withHash: true,
        colourOnly: true,
        onSaveColor: _this.onUpdateEditingColor,
        initialValue: {
          hex: editingLabel.color
        }
      }), /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
        key: "label-input",
        className: "labels__content__edit__input",
        label: "Label Name",
        defaultValue: editingLabel.label,
        onChange: _this.onUpdateEditingLabel
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "onSaveLabel", function () {
      var editingLabel = _this.state.editingLabel;

      if (!editingLabel) {
        return;
      }

      var _this$props = _this.props,
          updateProject = _this$props.updateProject,
          labels = _this$props.labels;

      var newLabels = _toConsumableArray(labels);

      var labelIndex = newLabels.findIndex(function (label) {
        return label.id === editingLabel.id;
      });
      newLabels.splice(labelIndex, 1, editingLabel);
      updateProject({
        labels: newLabels
      });

      _this.setState({
        editingLabel: void 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSaveAssetLabels", function () {
      var _this$props2 = _this.props,
          onUpdateLabelsForAsset = _this$props2.onUpdateLabelsForAsset,
          onClose = _this$props2.onClose;
      var selectedLabels = _this.state.selectedLabels;
      onUpdateLabelsForAsset(selectedLabels);
      onClose();
    });

    _this.state = {
      selectedLabels: props.selectedLabels || []
    };
    return _this;
  }

  _createClass(EditLabels, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          onBack = _this$props3.onBack,
          onClose = _this$props3.onClose,
          labels = _this$props3.labels;
      var editingLabel = this.state.editingLabel;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "labels"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "labels__header"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
        onClick: editingLabel ? this.resetEditingLabel : onBack,
        name: "return",
        size: 15
      }), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        heading5: true
      }, !editingLabel ? 'Select Label' : 'Change Label'), /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
        onClick: onClose,
        name: "close",
        size: 15,
        color: "regent",
        hoverColor: "denim"
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "labels__content"
      }, editingLabel ? this.renderEditContent() : labels.map(this.renderLabel)), /*#__PURE__*/_react.default.createElement("div", {
        className: "labels__footer"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
        onClick: editingLabel ? this.onSaveLabel : this.onSaveAssetLabels
      }, "Save Changes")));
    }
  }]);

  return EditLabels;
}(_react.Component);

exports.default = EditLabels;